<template>
  <div class="forgot-password-page d-flex align-items-center justify-content-center">
    <div class="forgot-password-card">
      <div class="text-center mb-4">
        <img src="images/logo-white-shadow.svg" alt="Logo" class="forgot-password-logo mb-2">
        <h1 class="forgot-password-title">
          Mot de passe oublié
        </h1>
      </div>

      <output v-if="requestSent" class="text-center d-block">
        <p class="forgot-password-description">
          Si un compte correspond à cette adresse, vous recevrez un e-mail avec les instructions de réinitialisation.
        </p>
        <p class="forgot-password-help">
          Pensez à vérifier vos courriers indésirables.
        </p>
        <b-button variant="primary" block class="mt-4" @click="goToLogin">
          Retour à la connexion
        </b-button>
      </output>

      <form v-else @submit.prevent="handleSubmit">
        <p class="forgot-password-description">
          Saisissez l'adresse e-mail associée à votre compte. Nous vous enverrons un lien si un compte correspond.
        </p>

        <b-form-group label="Adresse e-mail" label-for="forgot-password-email" class="forgot-password-label">
          <b-form-input id="forgot-password-email" v-model.trim="email" type="email" autocomplete="email"
                        required autofocus :disabled="isSubmitting" @input="clearError" />
        </b-form-group>

        <div v-if="errorMessage" class="forgot-password-error text-center" role="alert">
          {{ errorMessage }}
        </div>

        <b-button type="submit" variant="primary" block class="mt-4" :disabled="isSubmitting">
          {{ isSubmitting ? 'Envoi...' : 'Envoyer le lien' }}
        </b-button>

        <b-button type="button" variant="link" block class="mt-2" :disabled="isSubmitting" @click="goToLogin">
          Retour à la connexion
        </b-button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from '@/libs/axiosIns'
import {
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'

export default {
  name: 'ForgotPassword',
  components: {
    BButton,
    BFormGroup,
    BFormInput,
  },
  data() {
    return {
      email: '',
      errorMessage: null,
      isSubmitting: false,
      requestSent: false,
    }
  },
  methods: {
    clearError() {
      this.errorMessage = null
    },
    goToLogin() {
      this.$router.replace({ name: 'login' })
    },
    async handleSubmit() {
      this.clearError()
      this.isSubmitting = true

      try {
        await axios.post('Auth/ForgotPassword', { email: this.email })
        this.requestSent = true
      } catch (error) {
        if (error.response && error.response.status === 429) {
          this.errorMessage = 'Trop de demandes. Veuillez patienter avant de réessayer.'
        } else if (error.response) {
          this.errorMessage = "La demande n'a pas pu être envoyée. Veuillez réessayer plus tard."
        } else {
          this.errorMessage = "Une erreur réseau s'est produite. Vérifiez votre connexion."
        }
      } finally {
        this.isSubmitting = false
      }
    },
  },
}
</script>

<style scoped>
.forgot-password-page {
  min-height: 100vh;
  padding: 1rem;
  color: white;
  background: #202329 url('/images/refuge.jpg') center / cover;
  position: relative;
}

.forgot-password-page::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.62);
}

.forgot-password-card {
  width: min(100%, 430px);
  padding: 2rem 3rem;
  border-radius: 10px;
  background: rgba(46, 46, 46, 0.9);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  position: relative;
}

.forgot-password-logo {
  max-width: 180px;
}

.forgot-password-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.forgot-password-description,
.forgot-password-help {
  color: #e5e5e5;
}

.forgot-password-label label {
  color: white !important;
}

.forgot-password-error {
  color: #ffb3b3;
  font-size: 0.9rem;
  font-weight: 800;
}

@media (max-width: 480px) {
  .forgot-password-card {
    padding: 1.5rem;
  }
}
</style>
